
















































































































import {Component, Vue, Ref} from 'vue-property-decorator'
import VideoTimeline from '@/components/VideoTimeline/VideoTimeline.vue'
import Timeline from '@/components/Timeline.vue'
import ShotMenu from '@/components/ShotMenu.vue'
import {Shot, ShotTypes, generateRandomShots, ShotOrderChange, StillShot, VideoShot, SceneShot} from "@/store/shots"
import StillShotEditor from '@/components/StillShotEditor.vue'
import VideoShotEditor from "@/components/VideoShotEditor.vue"
import {shotStore, projectStore, userStore} from '@/store'
import SceneShotEditor from '@/components/SceneShotEditor.vue'
import VideoTrimmer from '@/components/VideoTrimmer/VideoTrimmer.vue'
import FullscreenModeButton from '@/components/FullscreenModeButton.vue'
import AppProjectSplashScreen from '@/components/App/Project/AppProjectSplashScreen.vue'

@Component({
  components: {
    VideoTrimmer,
    SceneShotEditor,
    Timeline, VideoTimeline, ShotMenu,
    StillShotEditor, VideoShotEditor,
    FullscreenModeButton,
    AppProjectSplashScreen,
  }
})
export default class ShotDesigner extends Vue {
  playing = false           // is video or 3d scene currently playing?
  @Ref() readonly videoShotEditor!: VideoShotEditor
  showRightTimeline = false
  expandTimeline = false
  mobileDialog = false

  // videoTimelineVisible: boolean | null = true
  get videoTimelineVisible(): boolean | null | undefined {
    return userStore.profile?.ui.shotDesigner.shotTimeline.open
  }

  set videoTimelineVisible(open: boolean | null | undefined) {
    userStore.setUIStateShotDesignerShotTimelineOpen(open)
    userStore.saveProfile()
  }

  get project() {
    return projectStore.project
  }
  get shots(): Shot[] {
    return projectStore.shots
  }
  get nShots() {
    return projectStore.shots.length
  }
  get currentShot() {
    return projectStore.currentShot
  }
  get videoTimelineToggleIcon() {
    return this.videoTimelineVisible ? 'arrow_right' : 'arrow_left'
  }

  // Project dialogs
  openNewProjectDialog() {
    this.$emit('openNewProjectDialog')
  }

  openLoadProjectDialog() {
    this.$emit('openLoadProjectDialog')
  }


  /**
   * Add a still shot at the given index, or at the end
   */
  addShot(kind: ShotTypes, idx?: number) {
    if (!this.project)
      return
    const shot = generateRandomShots(1, this.nShots+1, kind)[0]
    projectStore.addShot(shot)
    Vue.$log.debug('Saved test shot', shot)
  }
  async deleteShot(idx: number) {
    if (!this.shots[idx] || !this.project)
      return
    await projectStore.deleteShot(this.shots[idx])
  }

  async onShotOrderChanged(change: ShotOrderChange) {
    await projectStore.changeShotOrder(change)
  }

  // Updates current shot selection
  async onCurrentShotSelected(shot: Shot) {
    if (!this.project)
      return
    try {
      await projectStore.setCurrentShotId(shot.id)
    } catch (e) {
      this.$toast.error('Current shot save failed!')
    }
  }

  onTimelinePlay() {
    if (this.videoShotEditor)
      this.videoShotEditor.setPlaying(true)
  }

  onTimelinePause() {
    if (this.videoShotEditor)
      this.videoShotEditor.setPlaying(false)
  }

  async onUpdateShotImage(url: string) {
    if (!this.currentShot)
      return

    await shotStore.updateShotImageUrl({shot: this.currentShot, imageUrl: url})
  }

  async onUpdateShotVideo(url: string) {
    if (!this.currentShot)
      return

    await shotStore.updateShotVideoUrl({shot: this.currentShot, videoUrl: url})
  }

  async onUpdateShotDuration(duration: number) {
    if (!this.currentShot)
      return
    await shotStore.updateShotDuration({shot: this.currentShot, newDuration: duration})
  }

  // user dragged CTI to new time
  async onUpdateTime(time: number) {
    if (!this.currentShot)
      return
    if (time < 0)
      time = 0
    if (time > this.currentShot.durationInSec)
      time = this.currentShot.durationInSec
    if (this.playing) {
      // set video time; that will update local time
      this.videoShotEditor.setVideoTime(time)
    } else {
      await projectStore.setLocalTime(time)
    }
  }
  // Video player calls this every new frame during playback, and when
  // user uses video controls.
  async onUpdateVideoTime(time: number) {
    if (!this.currentShot)
      return
    // Set local time to update CTI
    // (Video knows it's playing and won't try to seek)
    await projectStore.setLocalTime(time)
  }

  get store() {
    return this
  }

  get currentIsStillShot() {
    return this.currentShot && (this.currentShot as StillShot).kind === 'still'
  }

  get currentIsVideoShot() {
    return this.currentShot && (this.currentShot as VideoShot).kind === 'video'
  }

  get currentIsSceneShot() {
    return this.currentShot && (this.currentShot as SceneShot).kind === 'scene'
  }

  get showProjectSplashScreen(): boolean {
    return (!this.project)
  }

  onVideoStop(ev: Event) {
    this.playing = false
  }

  toggleVideoTimelineDrawer() {
    this.videoTimelineVisible = !this.videoTimelineVisible
  }

  maybeShowMobileDialog() {
    let shown = localStorage.getItem('mobileDialogShown')
    let bp = this.$vuetify.breakpoint.mobile
    if (!shown && bp) {
      this.mobileDialog = true // show dialog
      localStorage.setItem('mobileDialogShown', '1')
    }
  }

  async mounted() {
    this.maybeShowMobileDialog()
  }
}
